define('editor/edit/map/controls/viewport',['leaflet-viewport'], function () {
    var control = function (options) {
        var self = this;

        self.options = options;

        self.addToMap = function () {
            self.currentDimensions = { width: self.options.editorMap.width, height: self.options.editorMap.height };
            self.control = L.viewport(self.currentDimensions);

            self.control.addTo(self.options.mapControl);


        };

        self.remove = function () {
            self.control.remove();
        };

        self.updateDimensions = function (dimensions) {
            self.currentDimensions = dimensions;
            self.control.resize(self.currentDimensions);
        };

        self.getBoundingBox = function () {
            var mapsize = self.options.mapControl.getSize();
            var topleftpoint = L.point((mapsize.x - self.currentDimensions.width) / 2, (mapsize.y - self.currentDimensions.height) / 2);
            var bottomrightpoint = L.point(topleftpoint.x + self.currentDimensions.width, topleftpoint.y + self.currentDimensions.height);
            var topleftlocation = self.options.mapControl.containerPointToLatLng(topleftpoint);
            var bottomrightlocation = self.options.mapControl.containerPointToLatLng(bottomrightpoint);
            //console.log({
            //    swlat: bottomrightlocation.lat,
            //    swlon: topleftlocation.lng,
            //    nelat: topleftlocation.lat,
            //    nelon: bottomrightlocation.lng
            //});
            return {
                swlat: bottomrightlocation.lat,
                swlon: topleftlocation.lng,
                nelat: topleftlocation.lat,
                nelon: bottomrightlocation.lng
            };
        };
    };

    return control;
});
